import { Fuel, Minus, Plus, WashingMachine, Wind, Shirt, BedDouble, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";

const ICONS = { washing: WashingMachine, wind: Wind, iron: Shirt, bed: BedDouble, truck: Truck };
const km = (n) => n.toLocaleString("es-ES", { maximumFractionDigits: 1 });

export const ServicePicker = ({ services, qty, onChange, config }) => (
  <div className="space-y-4" data-testid="booking-services-list">
    {config && (
      <div className="flex items-start gap-3 bg-cyan-50 border border-cyan-100 rounded-2xl p-4 text-sm text-cyan-900" data-testid="fuel-info-banner">
        <Fuel className="h-5 w-5 text-cyan-600 shrink-0 mt-0.5" />
        <p>
          <strong>Gasolina del desplazamiento:</strong> gratis si estás a {km(config.free_km)} km o menos del local (Actur);
          a partir de ahí, {config.rate_per_km.toFixed(2)} € por cada km extra. Se calcula automáticamente con tu dirección en el siguiente paso.
        </p>
      </div>
    )}
    {services.map((s) => {
      const Icon = ICONS[s.icon] || WashingMachine;
      return (
        <div key={s.id} className="bg-white border border-slate-200 rounded-2xl p-4 sm:p-5 flex items-center gap-3 sm:gap-4 transition-shadow duration-200 hover:shadow-md">
          <span className="hidden sm:inline-flex items-center justify-center h-11 w-11 rounded-xl bg-cyan-50 text-cyan-600 flex-shrink-0">
            <Icon className="h-5 w-5" />
          </span>
          <div className="flex-1 min-w-0">
            <h3 className="font-heading font-semibold text-slate-900 leading-snug">{s.name}</h3>
            <p className="text-sm text-slate-500">{s.price.toFixed(2)} € {s.unit}</p>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            <Button type="button" size="icon" variant="outline" className="rounded-full h-10 w-10 sm:h-9 sm:w-9"
              data-testid={`qty-minus-${s.id}`} onClick={() => onChange(s.id, -1)} aria-label={`Quitar ${s.name}`}>
              <Minus className="h-4 w-4" />
            </Button>
            <span className="w-6 text-center font-semibold tabular-nums" data-testid={`qty-value-${s.id}`}>{qty[s.id] || 0}</span>
            <Button type="button" size="icon" className="rounded-full h-10 w-10 sm:h-9 sm:w-9 bg-cyan-500 hover:bg-cyan-600"
              data-testid={`qty-plus-${s.id}`} onClick={() => onChange(s.id, 1)} aria-label={`Añadir ${s.name}`}>
              <Plus className="h-4 w-4" />
            </Button>
          </div>
        </div>
      );
    })}
  </div>
);
